export default {
  NONE: "none",
  DIRECT: "direct",
  CLICK: "click",
  PAYME: "payme"
};
